import { createContext } from "react";

export const UserContext = createContext({
  email: "",
  data: undefined,
  refresh: () => {},
});
